import React from 'react';

import SelectedItemsControls from '@Containers/ResultToolbar/SelectedItemsControls';
import RsTableToolbarButton from '@Pages/RetroSynthesis/components/RsTableToolbarButton';
import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/function-component-definition
const RsProjectRoutesToolbar = ({ selectedCount = 0, onSelectAllClick, isAllSelected, onLimitToClick, onDeleteClick, displayedItems }) => (
  <RsTableToolbar>
    <div className="rs-table-toolbar__left-controls">
      <SelectedItemsControls
        checkAllItems={() => onSelectAllClick()}
        allItemsSelected={isAllSelected}
        currentSelectedItems={selectedCount}
        someItemsSelected={selectedCount > 0 && !isAllSelected}
      />
      <RsTableToolbarButton
        icon="screenshot"
        label="Limit to"
        onClick={() => onLimitToClick()}
        disabled={!selectedCount || !displayedItems || displayedItems <= 1}
      />
      <RsTableToolbarButton icon="trash" label="Delete" onClick={() => onDeleteClick()} disabled={!selectedCount || selectedCount <= 0} />
    </div>
    <div className="rs-table-toolbar__center-controls" />
    <div className="rs-table-toolbar__right-controls">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className="rx-checkbox--label" htmlFor="allResults" title="Select all">
        <span className="icon-only-text-label">Select all results</span>
      </label>
    </div>
  </RsTableToolbar>
);

export default RsProjectRoutesToolbar;

RsProjectRoutesToolbar.defaultProps = {
  onLimitToClick: () => null,
  onSelectAllClick: () => null,
  onDeleteClick: () => null,
};

RsProjectRoutesToolbar.propTypes = {
  selectedCount: PropTypes.number,
  displayedItems: PropTypes.number,
  onSelectAllClick: PropTypes.func,
  isAllSelected: PropTypes.bool,
  onLimitToClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
};
